import { z } from 'zod';
/**
 * Schemas for the Claude Desktop hook plugin API key surface.
 *
 * Plugin keys are organization-level (`userId IS NULL`, `key_type = 'plugin'`)
 * keys with a `kirinp_` prefix. Multiple can be active per org. They are minted
 * by the "Download Plugin" flow on the Get Started page and never displayed in
 * plaintext after that download — only metadata is exposed via these schemas.
 */
export const pluginApiKeySchema = z.object({
    id: z.string(),
    keyPrefix: z.string(),
    name: z.string().nullable(),
    createdAt: z.coerce.date(),
    expiresAt: z.coerce.date().nullable(),
    lastUsedAt: z.coerce.date().nullable(),
    isActive: z.boolean(),
});
export const pluginApiKeyListSchema = z.array(pluginApiKeySchema);
export const expirePluginApiKeyResponseSchema = z.object({
    id: z.string(),
});
//# sourceMappingURL=plugin-api-keys.js.map